import { flexRender } from "@tanstack/react-table";
import type { Cell, RowData } from "@tanstack/table-core";
import { cn } from "../../../utils/classes";
import { getStickyClasses } from "../utils/sticky";

interface TableBodyCellProps<D> {
  cell: Cell<D, unknown>;
}
export function TableBodyCell<D extends RowData>({
  cell,
}: TableBodyCellProps<D>) {
  const align =
    typeof cell.column.columnDef.meta?.align === "function"
      ? cell.column.columnDef.meta.align(cell.getContext())
      : cell.column.columnDef.meta?.align;
  return (
    <td
      key={cell.id}
      data-column={cell.column.id}
      className={cn(
        "h-full p-1 bg-white flex flex-row whitespace-pre-wrap items-center",
        getStickyClasses(cell.column),
        {
          "justify-start": align === "left",
          "justify-center": align === "center",
          "justify-end": align === "right",
        },
        cell.column.columnDef.meta?.cellClass,
      )}
      style={{
        containIntrinsicSize: "auto",
        // TODO: Look at reenabling
        // ...getStickyStyling(cell.column),
      }}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
}
